import { render, staticRenderFns } from "./BaseLightbox.vue?vue&type=template&id=536951f6&"
import script from "./BaseLightbox.vue?vue&type=script&lang=js&"
export * from "./BaseLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports